<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 mb-1 text-primary font-weight-bold">Top Banners</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Top Banner</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Name"
            label-for="input-1"
          >
            <input
              v-model="items.name"
              v-validate="'required'"
              name="name"
              data-vv-as="Name"
              placeholder="Name"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image URL WebP (Desktop):"
            label-for="input-1"
          >
            <!-- <input
              v-model="items.image_desktop_webp"
              v-validate="'required'"
              name="imagedesktop"
              data-vv-as="Url Image Desktop"
              placeholder="Url Image Desktop"
              class="form-control"
            /> -->
            <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image (Desktop)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(1920px x 700px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileDesktop"
                    name="imagedesktop"
                    data-vv-as="Image Desktop WebP"
                    v-validate="'minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:webp'"
                    style="display: none"
                    v-on:change="onChangeFileDesktop()"
                  />
                  <b-button
                    @click="$refs.fileDesktop.click()"
                    v-show="!items.image_desktop_webp && !fileDesktop"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_desktop_webp || fileDesktop"
                    variant="primary"
                    @click="modalDesktop = !modalDesktop"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileDesktop.click()"
                    v-show="items.image_desktop_webp || fileDesktop"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('imagedesktop') }}</p>
          </b-form-group>
          
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image URL WebP (Mobile):"
            label-for="input-1"
          >
            <!-- <input
              v-model="items.image_mobile_webp"
              v-validate="'required'"
              name="imagemobile"
              data-vv-as="Url Image Mobile"
              placeholder="Url Image Mobile"
              class="form-control"
            /> -->
            <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image (Mobile)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(640px x 600px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileMobile"
                    name="imagemobile"
                    data-vv-as="Image Mobile WebP"
                    v-validate="'minimalDimensions:640,600|ratiolDimensions:64,60|size:2000|ext:webp'"
                    style="display: none"
                    v-on:change="onChangeFileMobile()"
                  />
                  <b-button
                    @click="$refs.fileMobile.click()"
                    v-show="!items.image_mobile_webp && !fileMobile"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_mobile_webp || fileMobile"
                    variant="primary"
                    @click="modalMobile = !modalMobile"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileMobile.click()"
                    v-show="items.image_mobile_webp || fileMobile"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('imagemobile') }}</p>
          </b-form-group>
          
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image URL JPG (Desktop):"
            label-for="input-1"
          >
            <!-- <input
              v-model="items.image_desktop_jpg"
              v-validate="'required'"
              name="imagedesktop"
              data-vv-as="Url Image Desktop"
              placeholder="Url Image Desktop"
              class="form-control"
            /> -->
            <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image (Desktop)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(1920px x 700px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileDesktopJPG"
                    name="imagedesktopJPG"
                    data-vv-as="Image Desktop JPG"
                    v-validate="'minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:jpg,png,gif,jpeg'"
                    style="display: none"
                    v-on:change="onChangeFileDesktopJPG()"
                  />
                  <b-button
                    @click="$refs.fileDesktopJPG.click()"
                    v-show="!items.image_desktop_jpg && !fileDesktopJPG"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_desktop_jpg || fileDesktopJPG"
                    variant="primary"
                    @click="modalDesktopJPG = !modalDesktopJPG"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileDesktopJPG.click()"
                    v-show="items.image_desktop_jpg || fileDesktopJPG"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('imagedesktopJPG') }}</p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image URL JPG (Mobile):"
            label-for="input-1"
          >
            <!-- <input
              v-model="items.image_mobile_jpg"
              v-validate="'required'"
              name="imagemobile"
              data-vv-as="Url Image Mobile"
              placeholder="Url Image Mobile"
              class="form-control"
            /> -->
            <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image (Mobile)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(640px x 600px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileMobileJPG"
                    name="imagemobileJPG"
                    data-vv-as="Image Mobile JPG"
                    v-validate="'minimalDimensions:640,600|ratiolDimensions:64,60|size:2000|ext:jpg,png,gif,jpeg'"
                    style="display: none"
                    v-on:change="onChangeFileMobileJPG()"
                  />
                  <b-button
                    @click="$refs.fileMobileJPG.click()"
                    v-show="!items.image_mobile_jpg && !fileMobileJPG"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_mobile_jpg || fileMobileJPG"
                    variant="primary"
                    @click="modalMobileJPG = !modalMobileJPG"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileMobileJPG.click()"
                    v-show="items.image_mobile_jpg || fileMobileJPG"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('imagemobileJPG') }}</p>
          </b-form-group>
          
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Heading (Bahasa)"
            label-for="input-1"
          >
            <input
              v-model="items.title.id"
              v-validate="'required'"
              name="title_id"
              data-vv-as="Heading Bahasa"
              placeholder="Heading in Bahasa"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Heading (English)"
            label-for="input-1"
          >
            <input
              v-model="items.title.en"
              v-validate="'required'"
              name="title_en"
              data-vv-as="Heading English"
              placeholder="Heading in English"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Sub Heading (Bahasa)"
            label-for="input-1"
          >
            <textarea
              id="textarea"
              v-model="items.sub_title.id"
              v-validate="'required'"
              name="sub_title_id"
              data-vv-as="Sub Heading Bahasa"
              placeholder="Sub Heading in Bahasa..."
              rows="3"
              max-rows="6"
              class="form-control"
            ></textarea>
            <b-form-invalid-feedback
              id="input-sub_title_id-feedback"
            >{{ veeErrors.first('sub_title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Sub Heading (English)"
            label-for="input-1"
          >
            <textarea
              id="textarea"
              v-model="items.sub_title.en"
              v-validate="'required'"
              name="sub_title_en"
              data-vv-as="Sub Heading English"
              placeholder="Sub Heading in English..."
              rows="3"
              max-rows="6"
              class="form-control"
            ></textarea>
            <b-form-invalid-feedback
              id="input-sub_title_en-feedback"
            >{{ veeErrors.first('sub_title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="With Button" label-for="input-1">
            <b-form-radio-group
              id="radio-group-1"
              v-model="items.button.is_active"
              :options="options1"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
        <br />
      </b-row>
      <b-row v-show="items.button.is_active">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Button Text (Bahasa)" label-for="input-1">
            <input
              :disabled="items.button.is_active == false"
              v-model="items.button.id"
              v-validate="'required'"
              data-vv-as="Button Text Bahasa"
              name="button_id"
              class="form-control"
              placeholder="Button Text in Bahasa"
            />
            <b-form-invalid-feedback
              id="input-question_id-feedback"
            >{{ veeErrors.first('button_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Button Text (English)" label-for="input-1">
            <input
              :disabled="items.button.is_active == false"
              v-model="items.button.en"
              v-validate="'required'"
              data-vv-as="Button Text English"
              name="button_en"
              class="form-control"
              placeholder="Button Text in English"
            />
            <b-form-invalid-feedback
              id="input-question_id-feedback"
            >{{ veeErrors.first('button_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col></b-col>
        <br />
      </b-row>
      <b-row v-show="items.button.is_active">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Button Url" label-for="input-1">
            <b-form-radio-group
              id="radio-group-url"
              v-model="items.button.is_article"
              :options="options3"
              name="radio-url"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="items.button.is_active">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Article"
            label-for="input-1"
            v-show="items.button.is_article == true"
          >
            <vue-multiselect
              id="ajax2"
              open-direction="bottom"
              v-model="items.button.article_selected"
              v-validate="items.button.is_article == true && items.button.is_active == true ? 'required':''"
              data-vv-as="Article Url"
              name="article_url"
              :preserve-search="true"
              :options="dataArticle"
              :custom-label="nameWithLang"
              placeholder="Type to search Article"
              track-by="id"
              label="slug"
              class="text-capitalize"
              :loading="isLoadingArticle"
              :searchable="true"
              @search-change="asyncFindArticle"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.title.id }}</span>
                </div>
              </template>
            </vue-multiselect>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('article_url') }}</p>
          </b-form-group>
          <b-form-group
            id="fieldset-1"
            label="Other URL"
            label-for="input-1"
            v-show="items.button.is_article == false"
          >
            <input
              v-model="items.button.button_url"
              v-validate="items.button.is_article == false && items.button.is_active == true ? 'required':''"
              name="button_url"
              data-vv-as="Other URL"
              class="form-control"
              placeholder="URL"
            />
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('button_url') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="With Download Button" label-for="input-1">
            <b-form-radio-group
              id="download-button"
              v-model="items.is_with_download_button"
              :options="options1"
              name="download-button"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="items.is_with_download_button">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Play Store" label-for="input-1">
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Icon Download Play Store</b>
                    <sup class="text-secondary pl-3">(2 Mb)&nbsp;(160px x 50px)</sup>
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="play_store_icon"
                      name="playstoreicon"
                      v-validate="is_with_download_button == true && is_active == true ? 'required|minimalDimensions:160,50|size:2000|ext:jpg,png,gif,jpeg,svg,webp':'minimalDimensions:160,50|size:2000|ext:jpg,png,gif,jpeg,svg,webp'"
                      style="display: none"
                      @change="onChangeFilePlayStore()"
                    />
                    <b-button
                      @click="$refs.play_store_icon.click()"
                      v-show="!items.download_button.play_store_icon && !play_store_icon"
                      variant="primary"
                      class="ml-5"
                    >Select Icon</b-button>
                    <b-button
                      v-show="items.download_button.play_store_icon || play_store_icon"
                      variant="primary"
                      @click="modalPlayStore = !modalPlayStore"
                      class="mr-2"
                    >Preview</b-button>
                    <b-button
                      @click="$refs.play_store_icon.click()"
                      v-show="items.download_button.play_store_icon || play_store_icon"
                      variant="outline-primary"
                      class
                    >Change File</b-button>
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('playstoreicon') }}</p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="App Store" label-for="input-1">
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Icon Download App Store</b>
                    <sup class="text-secondary pl-3">(2 Mb)&nbsp;(160px x 50px)</sup>
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="app_store_icon"
                      name="appstoreicon"
                      v-validate="is_with_download_button == true && is_active == true ? 'required|minimalDimensions:160,50|size:2000|ext:jpg,png,gif,jpeg,svg,webp':'minimalDimensions:160,50|size:2000|ext:jpg,png,gif,jpeg,svg,webp'"
                      style="display: none"
                      @change="onChangeFileAppStore()"
                    />
                    <b-button
                      @click="$refs.app_store_icon.click()"
                      v-show="!items.download_button.app_store_icon && !app_store_icon"
                      variant="primary"
                      class="ml-5"
                    >Select Icon</b-button>
                    <b-button
                      v-show="items.download_button.app_store_icon || app_store_icon"
                      variant="primary"
                      @click="modalAppStore = !modalAppStore"
                      class="mr-2"
                    >Preview</b-button>
                    <b-button
                      @click="$refs.app_store_icon.click()"
                      v-show="items.download_button.app_store_icon || app_store_icon"
                      variant="outline-primary"
                      class
                    >Change File</b-button>
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('appstoreicon') }}</p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label-for="input-1">
            <input
              v-model="items.download_button.play_store_url"
              v-validate="is_with_download_button == true && is_active == true ? 'required':''"
              data-vv-as="URL Play Store"
              name="play_store_url"
              class="form-control"
              placeholder="URL Play Store"
            />
            <b-form-invalid-feedback
              id="input-question_id-feedback"
            >{{ veeErrors.first('play_store_url') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label-for="input-1">
            <input
              v-model="items.download_button.app_store_url"
              v-validate="is_with_download_button == true && is_active == true ? 'required':''"
              data-vv-as="URL App Store"
              name="app_store_url"
              class="form-control"
              placeholder="URL App Store"
            />
            <b-form-invalid-feedback
              id="input-question_id-feedback"
            >{{ veeErrors.first('app_store_url') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              id="radio-group-2"
              v-model.trim="items.status"
              :options="options2"
              name="radio-status"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Period" label-for="input-1">
            <b-form-group id="fieldset-1" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Select Date"
                    v-model="items.period.start_date"
                    :format="customFormatter"
                    :disabled="items.is_always_active"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col class="pt-1 px-4 form-control del-calender-select border-left-0" md="2">
                    <b-row class="pt-1">
                      <b-col>
                        <b-link @click="resetStardate" style="text-decoration:none">
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
            </b-form-group>
          </b-form-group>
        </b-col>
        <b-col>
          <p class="mb-2">&nbsp;</p>
          <b-form-group id="fieldset-1" label-for="input-1">
            <b-row class="m-0">
              <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
              </b-col>
              <b-col class="px-0">
                <datepicker
                  input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                  placeholder="Select Date"
                  v-model="items.period.end_date"
                  :format="customFormatter"
                  :disabled="items.is_always_active"
                  :disabledDates="disabledDates"
                ></datepicker>
              </b-col>
              <b-col align="left" md="1" class="px-0">
                <b-col class="pt-1 px-4 form-control del-calender-select border-left-0" md="2">
                  <b-row class="pt-1">
                    <b-col>
                      <b-link @click="resetEnddate" style="text-decoration:none">
                        <i class="text-danger fas fa-times"></i>
                      </b-link>
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <br />
      <b-row>
        <b-col align="right">
          <b-button variant="primary" @click="put()" :disabled="loading" size="lg" class="mr-3">Save</b-button>
          <router-link :to="{name: 'homePage'}">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalMobile" title="Preview Image" size="xl">
      <img
        v-show="!fileMobile"
        v-if="items.image_mobile_webp"
        width
        height="400px"
        :src="items.image_mobile_webp"
      />
      <img v-show="fileMobile" v-if="urlMobile" width height="400px" :src="urlMobile" />
    </b-modal>
    <b-modal v-model="modalDesktop" title="Preview Image" size="xl">
      <img
        v-show="!fileDesktop"
        v-if="items.image_desktop_webp"
        width
        height="400px"
        :src="items.image_desktop_webp"
      />
      <img v-show="fileDesktop" v-if="urlDesktop" width height="400px" :src="urlDesktop" />
    </b-modal>
    <b-modal v-model="modalMobileJPG" title="Preview Image" size="xl">
      <img
        v-show="!fileMobileJPG"
        v-if="items.image_mobile_jpg"
        width
        height="400px"
        :src="items.image_mobile_jpg"
      />
      <img v-show="fileMobileJPG" v-if="urlMobileJPG" width height="400px" :src="urlMobileJPG" />
    </b-modal>
    <b-modal v-model="modalDesktopJPG" title="Preview Image" size="xl">
      <img
        v-show="!fileDesktopJPG"
        v-if="items.image_desktop_jpg"
        width
        height="400px"
        :src="items.image_desktop_jpg"
      />
      <img v-show="fileDesktopJPG" v-if="urlDesktopJPG" width height="400px" :src="urlDesktopJPG" />
    </b-modal>
    <b-modal v-model="modalPlayStore" title="Preview Image" size="xl">
      <img v-show="urlPlayStore" v-if="urlPlayStore" width height="400px" :src="urlPlayStore" />
      <img
        v-show="!urlPlayStore"
        v-if="items.download_button.play_store_icon"
        width
        height="400px"
        :src="items.download_button.play_store_icon"
      />
    </b-modal>
    <b-modal v-model="modalAppStore" title="Preview Image" size="xl">
      <img v-show="urlAppStore" v-if="urlAppStore" width height="400px" :src="urlAppStore" />
      <img
        v-show="!urlAppStore"
        v-if="items.download_button.app_store_icon"
        width
        height="400px"
        :src="items.download_button.app_store_icon"
      />
    </b-modal>
    <br />
    <br />
  </div>
</template>

<script>
import _ from "lodash";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      widthMobile: null,
      heightMobile: null,
      widthDesktop: null,
      heightDesktop: null,
      InputImageMobile: false,
      InputImageDesktop: false,
      modalMobile: false,
      modalDesktop: false,
      fileDesktop: "",
      fileMobile: "",
      urlMobile: "",
      urlDesktop: "",
      modalMobileJPG: false,
      modalDesktopJPG: false,
      fileDesktopJPG: "",
      fileMobileJPG: "",
      urlMobileJPG: "",
      urlDesktopJPG: "",
      isLoadingArticle: false,
      searchTermArticle: "",
      modalPlayStore: false,
      modalAppStore: false,
      play_store_icon: "",
      play_store_url: "",
      app_store_icon: "",
      app_store_url: "",
      urlAppStore: "",
      urlPlayStore: "",
      dataArticle: [],
      items: [],
      options: [],
      options1: [
        { text: "No", value: false },
        { text: "Yes", value: true }
      ],
      options3: [
        { text: "Article", value: true },
        { text: "Other URL", value: false }
      ],
      options2: [
        { text: "Publish", value: "publish" },
        { text: "Archive", value: "archive" }
      ],
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      }
    };
  },
  beforeCreate() {
    this.$store.dispatch("homePageModule/getHomepage", this.$route.params.id);
    const formData = new FormData();
    formData.append("search_param", "");
    formData.append("limit", 10);
    formData.append("page", 1);
    formData.append("status", "publish");
    formData.append("status", "highlight");
    this.$store
      .dispatch("ArticleModule/getArticles2", formData)
      .then(response => {
        this.dataArticle = response.data.data.results;
        this.isLoadingArticle = false;
      })
      .catch(error => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.isLoadingArticle = false;
      });
  },
  created() {
    this.$store.watch(
      state => state.homePageModule.homepage_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    resetStardate() {
      this.items.period.start_date = "";
    },
    resetEnddate() {
      this.items.period.end_date = "";
    },
    asyncFindArticle(query) {
      this.isLoadingArticle = true;
      this.searchTermArticle = query;
      this.getWorksAsync();
    },
    getWorksAsync: _.debounce(function() {
      const article = this.searchTermArticle.toLowerCase();
      const formData = new FormData();
      formData.append("search_param", article);
      formData.append("limit", 10);
      formData.append("page", 1);
      formData.append("status", "publish");
      formData.append("status", "highlight");
      this.$store
        .dispatch("ArticleModule/getArticles2", formData)
        .then(response => {
          this.dataArticle = response.data.data.results;
          this.isLoadingArticle = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.isLoadingArticle = false;
        });
    }, 1000),
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Home Page!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              const startDate = moment(this.items.period.start_date).format(
                "YYYY-MM-DD"
              );
              const endDate = moment(this.items.period.end_date).format(
                "YYYY-MM-DD"
              );
              formData.append("image_desktop_webp", this.fileDesktop);
              formData.append("image_mobile_webp", this.fileMobile);
              formData.append("image_desktop_jpg", this.fileDesktopJPG);
              formData.append("image_mobile_jpg", this.fileMobileJPG);
              formData.append("name", this.items.name);
              formData.append("title_id", this.items.title.id);
              formData.append("title_en", this.items.title.en);
              formData.append("sub_title_id", this.items.sub_title.id);
              formData.append("sub_title_en", this.items.sub_title.en);
              formData.append("button_id", this.items.button.id);
              formData.append("button_en", this.items.button.en);
              formData.append(
                "is_with_download_button",
                this.items.is_with_download_button
              );
              formData.append("play_store_icon", this.play_store_icon);
              formData.append("app_store_icon", this.app_store_icon);

              formData.append(
                "play_store_url",
                this.items.download_button.play_store_url
              );
              formData.append(
                "app_store_url",
                this.items.download_button.app_store_url
              );

              formData.append("is_article", this.items.button.is_article);

              if (this.items.button.is_article) {
                formData.append(
                  "article_url",
                  this.items.button.article_selected.id
                );
                formData.append(
                  "slug",
                  this.items.button.article_selected.slug
                );
                formData.append(
                  "created_at_date_only",
                  this.items.button.article_selected.created_at_date_only
                );
              } else {
                formData.append(
                  "article_url",
                  this.items.button.article_selected.id
                );
                formData.append(
                  "slug",
                  this.items.button.article_selected.slug
                );
                formData.append(
                  "created_at_date_only",
                  this.items.button.article_selected.created_at_date_only
                );
              }
              formData.append("button_url", this.items.button.button_url);
              formData.append("is_active", this.items.button.is_active);
              formData.append("is_always_active", this.items.is_always_active);

              if (
                this.items.period.start_date == "" &&
                this.items.period.end_date != ""
              ) {
                const endDate = moment(this.items.period.end_date).format(
                  "YYYY-MM-DD"
                );
                formData.append("period_start", this.items.period.start_date);
                formData.append("period_end", endDate);
              }
              if (
                this.items.period.start_date != "" &&
                this.items.period.end_date == ""
              ) {
                const startDate = moment(this.items.period.start_date).format(
                  "YYYY-MM-DD"
                );
                formData.append("period_start", startDate);
                formData.append("period_end", this.items.period.end_date);
              }
              if (
                this.items.period.start_date != "" &&
                this.items.period.end_date != ""
              ) {
                const startDate = moment(this.items.period.start_date).format(
                  "YYYY-MM-DD"
                );
                const endDate = moment(this.items.period.end_date).format(
                  "YYYY-MM-DD"
                );

                formData.append("period_start", startDate);
                formData.append("period_end", endDate);
              }
              if (
                this.items.period.start_date == "" &&
                this.items.period.end_date == ""
              ) {
                formData.append("period_start", this.items.period.start_date);
                formData.append("period_end", this.items.period.end_date);
              }

              formData.append("status", this.items.status);
              this.$store
                .dispatch("homePageModule/putHomepage", {
                  id: this.$route.params.id,
                  formData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "homePage" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  this.serverError = error.response.data;
                  console.log(error);
                });
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$validator.errors.all(),
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        }
      });
    },
    onChangeFileDesktop() {
      this.fileDesktop = this.$refs.fileDesktop.files[0];
      const input = this.$refs.fileDesktop;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthDesktop = img.width;
            this.heightDesktop = img.height;
          };
          img.src = e.target.result;
          this.urlDesktop = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobile() {
      this.fileMobile = this.$refs.fileMobile.files[0];
      const input = this.$refs.fileMobile;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthMobile = img.width;
            this.heightMobile = img.height;
          };
          img.src = e.target.result;
          this.urlMobile = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileDesktopJPG() {
      this.fileDesktopJPG = this.$refs.fileDesktopJPG.files[0];
      const input = this.$refs.fileDesktopJPG;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthDesktop = img.width;
            this.heightDesktop = img.height;
          };
          img.src = e.target.result;
          this.urlDesktopJPG = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobileJPG() {
      this.fileMobileJPG = this.$refs.fileMobileJPG.files[0];
      const input = this.$refs.fileMobileJPG;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthMobile = img.width;
            this.heightMobile = img.height;
          };
          img.src = e.target.result;
          this.urlMobileJPG = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileAppStore() {
      this.app_store_icon = this.$refs.app_store_icon.files[0];
      const input = this.$refs.app_store_icon;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlAppStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFilePlayStore() {
      this.play_store_icon = this.$refs.play_store_icon.files[0];
      const input = this.$refs.play_store_icon;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlPlayStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>
